module.exports = __webpack_public_path__ + "img/default-JG.7ce86843.png";